// Employee / student code used as the biometric device UserID.
// The protocol documents the field as <UserID>1~99999999</UserID>, so any number
// in that range is valid -- no format is imposed beyond it.

const MAX_DIGITS = 8;

export const attendanceCodeError = (value) => {
        const code = String(value ?? '').trim();
        if (!code) {
                return null;
        }
        if (!/^\d+$/.test(code)) {
                return 'Code must contain digits only';
        }
        if (code.length > MAX_DIGITS) {
                return `Code cannot be more than ${MAX_DIGITS} digits`;
        }
        // the device numbers users from 1, so 0 is not a usable id
        if (Number(code) < 1) {
                return 'Code must be 1 or greater';
        }
        return null;
};

export default { attendanceCodeError };
